import * as React from 'react';
/**
 *
 * Original name: Data Rooms
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29923%3A6768
 *
 */
export const DataRoomsLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M12 9c-1.346 0-2 .655-2 2 0 1.067.41 1.699 1.25 1.915v2.086h1.5v-2.085c.84-.217 1.25-.85 1.25-1.915 0-1.346-.654-2-2-2Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.594 9.415 12 2.54 3.406 9.415l.938 1.171L5.5 9.661v9.34h13V9.66l1.157.925.937-1.171ZM7 17.5V8.461l5-4 5 4v9.04H7Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
